"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIcon = exports.IconWrapper = void 0;
var _Icon = _interopRequireDefault(require("../Icon"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _palette = require("../../styles/palette");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var StyledIcon = exports.StyledIcon = (0, _styledComponents["default"])(_Icon["default"]).attrs(function (p) {
  return {
    name: p.value === false ? 'checklists-close' : 'checkmark'
  };
}).withConfig({
  displayName: "styles__StyledIcon",
  componentId: "sc-1l76plx-0"
})(["width:14px;height:14px;color:", ";"], function (_ref) {
  var value = _ref.value;
  return value === false ? _palette.commonPalette.iconError : _palette.commonPalette.iconSuccess;
});
var IconWrapper = exports.IconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__IconWrapper",
  componentId: "sc-1l76plx-1"
})(["padding:4px 8px;border-radius:4px;display:inline-flex;align-items:flex-start;gap:10px;background-color:", ";margin-right:5px;"], function (_ref2) {
  var value = _ref2.value;
  return value === false ? _palette.commonPalette.bannerError : _palette.commonPalette.bannerSuccess;
});
//# sourceMappingURL=styles.js.map